<template>
  <PrivacySection title="12. Modifiche alla Privacy Policy">
    <p>
      Ci riserviamo il diritto di modificare questa Privacy Policy in qualsiasi momento. 
      Le modifiche entreranno in vigore dalla data di pubblicazione sul sito web o 
      nell'applicazione. L'utente è invitato a consultare periodicamente questa pagina 
      per essere informato di eventuali aggiornamenti.
    </p>
    <p>
      In caso di modifiche sostanziali, provvederemo a notificare gli utenti attraverso 
      i canali appropriati (notifica nell'applicazione, email, avviso sul sito web).
    </p>
    <p>
      La data dell'ultimo aggiornamento è indicata in fondo a questa Privacy Policy.
    </p>
  </PrivacySection>
</template>

<script>
import PrivacySection from '../PrivacySection.vue'

export default {
  name: 'PolicyChangesSection',
  components: {
    PrivacySection
  }
}
</script>

